module.exports = __webpack_public_path__ + "static/img/m3.e61b614e.png";